import { REO_CDN_DOMAIN } from '@/config';

export const getCDNPath = (path: string): string => {
    return REO_CDN_DOMAIN + path;
};
